import { render, staticRenderFns } from "./Chi_defaultSection.vue?vue&type=template&id=60b8917a&scoped=true"
import script from "./Chi_defaultSection.vue?vue&type=script&lang=ts"
export * from "./Chi_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./Chi_defaultSection.vue?vue&type=style&index=0&id=60b8917a&prod&lang=css"
import style1 from "./Chi_defaultSection.vue?vue&type=style&index=1&id=60b8917a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b8917a",
  null
  
)

export default component.exports